import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesksTurnsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getDesks(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_getTurnDeskList', item, options);
  }
  public getDesksStatus(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalIdList: [] };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/turnDesk/availables/count', item, options);
  }
  public getDeskInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_getDeskTurnDetails', item, options);
  }
  public addNewDesk(context, lang, udid, active, image, deskName, centerInternalId, turnTypeInternalId, voiceActivate, voicePrefix, deskPrefix, canAskCustomerName, dailyReset, smsNotifyDesk, smsInternalId, notifyPrevious, notifyLast, canPrint, ticketInternalId, countAutoReset, initialCount, limitCount, calendarsBound, showTurnsAtTotem, availableTurn, autoAdvance, dataType, hasVip) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, image, deskName, centerInternalId, turnTypeInternalId, voiceActivate, voicePrefix, deskPrefix, canAskCustomerName, dailyReset, smsNotifyDesk, smsInternalId, notifyPrevious, notifyLast, canPrint, ticketInternalId, countAutoReset, initialCount, limitCount, calendarsBound, showTurnsAtTotem, availableTurn, autoAdvance, dataType, hasVip };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveTurnDesk', item, options);
  }
  public updateDeskInfo(context, lang, udid, internalId, active, deskName, centerInternalId, turnTypeInternalId, deskPrefix, canAskCustomerName, dailyReset, voiceActivate, voicePrefix, smsNotifyDesk, smsInternalId, notifyPrevious, notifyLast, canPrint, ticketInternalId, showTurnsAtTotem, availableTurn, autoAdvance, dataType, hasVip) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, deskName, centerInternalId, turnTypeInternalId, deskPrefix, canAskCustomerName, dailyReset, voiceActivate, voicePrefix, smsNotifyDesk, notifyPrevious, notifyLast, smsInternalId, canPrint, ticketInternalId, showTurnsAtTotem, availableTurn, autoAdvance, dataType, hasVip };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveTurnDesk', item, options);
  }
  public updateDeskAutoResetInfo(context, lang, udid, internalId, countAutoReset, initialCount, limitCount) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, countAutoReset, initialCount, limitCount };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveTurnDeskResetLimits', item, options);
  }

  public updateDeskDeskNameTranslation(context, lang, udid, translatedNames) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { translatedNames };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/updateDeskNameTranslations', item, options);
  }
  public updateDeskSchedules(context, lang, udid, internalId, centerInternalId, active, deskCalendars) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, deskCalendars };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveTurnDesk', item, options);
  }
  public updateDeskStatus(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_updateStatusTurnDesk', item, options);
  }
  public updateDeskCapacity(context, lang, udid, internalId, capacity) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, capacity };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_updateDeskCapacity', item, options);
  }
  public deleteDesk(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_deleteTurnDesk', item, options);
  }
  public updateImageDesk(context, lang, udid, internalId, imageRaw, size) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageRaw, size};
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_updateImageTurnDesk', item, options);
  }
  public rebootDesk(context, lang, udid, internalId ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_rebootTurn', item, options);
  }
  public getDeskScheduleList(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_getDeskCalendarList', item, options);
  }
  public getDeskScheduleInfo(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_getDeskCalendarDetail', item, options);
  }
  public addNewDeskSchedule(context, lang, udid, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveTurnDeskCalendar', item, options);
  }
  public updateDeskSchedule(context, lang, udid, internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveTurnDeskCalendar', item, options);
  }
  public deleteDeskSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_deleteTurnDeskCalendar', item, options);
  }
  public getDeskTypes(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_listTurnType', item, options);
  }
  public getDeskDevices(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_listDevicesForTurnDesk', item, options);
  }
  public saveDeskDevices(context, lang, udid, internalId, devicesBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, devicesBound };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveDevicesForTurnDesk', item, options);
  }
  public getDeskLocations(context, lang, udid, centerInternalId, turnTypeInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, turnTypeInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_listDeskLocations', item, options);
  }
  public saveDeskLocations(context, lang, udid, internalId, locationsBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, locationsBound };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_saveLocationsForTurnDesk', item, options);
  }
  public pushTurn(context, lang, udid, deskId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { deskId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deskLocation/pushTurn', item, options);
  }
  public callBackLastTurn(context, lang, udid, deskId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { deskId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deskLocation/callBackLastTurn', item, options);
  }
  public getDeskExistingSchedules(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/calendar/list', item, options);
  }
  public linkExistingDeskSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_linkTurnDeskCalendar', item, options);
  }

}
